import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { appRoute } from 'app/railways/router/routes';

import { DetailsTrip } from '../features/details-trip/details-trip';

export const DetailsTripPage = observer(() => {
  const { id: tripId } = useTypedParams(appRoute.TRIP);

  const pageNotify = useNotifyFactory();

  if (!tripId) return null;

  return (
    <NotificationsProvider value={pageNotify}>
      <AppPage perm="PERM_ROUTE_TRIP_READ">
        <DetailsTrip tripId={tripId} />
      </AppPage>
    </NotificationsProvider>
  );
});
